import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const setWorkflowAppBackingSchema = z.object({
  connectedAppId: z.string(),
  workflowId: z.string(),
});

export const setWorkflowAppBacking = mutator({
  schema: setWorkflowAppBackingSchema,
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app, workflow } }) => {
    if (app.identifier !== "workflow") {
      throw userFacingError("This connector is not workflow-backed.");
    }
    // urlPattern, baseUrl, and the secret token are written server-side from the workflow's space — a client-supplied urlPattern would leak the proxy-injected token to an attacker URL.
    await tx.mutate.connectedApps.update({
      id: app.id,
      backingWorkflowId: workflow.id,
    });
  },
});
